var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M821.385-612q35.477 0 63.046 27.569Q912-556.862 912-521.385v55.668q0 6.025-1.615 13.53-1.616 7.505-4.846 13.879L788.308-159.384q-10.231 20.461-30.985 33.923Q736.569-112 714.462-112H370.769q-38.846 0-64.73-25.884-25.885-25.885-25.885-64.731v-371.539q0-18.256 6.846-35.282 6.846-17.026 19.539-29.718l184.23-186.462q17.847-19.615 40.231-24.846 22.385-5.231 40.154 3.385 17.77 8.615 24.039 30.923 6.269 22.308-.423 50.154l-36.154 154h262.769ZM154.367-112q-28.598 0-48.483-20.059Q86-152.119 86-180.615v-362.77q0-28.496 20.132-48.556Q126.265-612 154.863-612h16.923q28.598 0 48.483 20.059 19.885 20.06 19.885 48.556v363.539q0 28.496-20.133 48.171Q199.889-112 171.29-112h-16.923Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpFilled);
export default __webpack_public_path__ + "static/media/thumbUpFilled.b517cb4ff2bc2b740ad3021b09396c39.svg";
export { ForwardRef as ReactComponent };